class HomeController {
  constructor(User, $state, $rootScope, $uibModal, ngToast) {
    "ngInject";
    this.name = 'home';
    this.userId = User.getUserId();
    this.email = User.getUserEmail();
    this.User = User;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.ngToast = ngToast;
  }

  logout() {
    console.log("logout");
    this.User.logout().then(() => {
      this.$state.go('auth.login');
      location.reload();
    });
  }
}

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js